import React, { useState } from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import DisplayError from "../../dumb/DisplayError";
import useStatusThunk from "../../../hook/useStatusThunk";
import { setTasksDue } from "../../../redux/ducks/task";
import DateInput from "../../dumb/DateInput";

const SetTaskDue = props => {
    const [show, hide, renderModal] = useModal();
    const [d_setTasksDue, status, error, event] = useStatusThunk(setTasksDue);

    const [date, setDate] = useState(new Date());
    const [type, setType] = useState();

    event.onSuccess = () => {
        hide();
        setDate(new Date());
        setType(null);
    }

    return (
        <React.Fragment>
            <button className={"button button--primary " + props.className} onClick={show}>Set Due</button>

            {renderModal(
                <React.Fragment>
                    <div className="group">
                        <div className="label">Type</div>
                        <select className="select select--primary" onChange={e => setType(e.target.value)}>
                            <option disabled selected></option>
                            <option value="t">Translator</option>
                            <option value="e">Editor</option>
                        </select>
                    </div>

                    <div className="group">
                        <div className="label">Date</div>
                        <DateInput set={setDate} v={date} />
                    </div>

                    <div className="group">
                        <DisplayError error={error} />
                    </div>

                    <LoadingButton loading={status == "pending"} className="button--primary" onClick={() => { d_setTasksDue({ taskIDs: props.selectedTasks, date, type }) }}>Set Due</LoadingButton>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default SetTaskDue;